import axios from 'axios'
import store from '@/store'

const lms = axios.create({
  baseURL: process.env.VUE_APP_BASEURL_LRG,
  headers: {
    'Content-Type': 'application/json',
    Service: 'STAAGE',
    'X-gprim-specnav': window.navigator.userAgent,
    'X-gprim-specdev': 'WEB',
    'X-gprim-specver': '2.2.1'
  },
  timeout: 30000,
  withCredentials: false
})

lms.interceptors.request.use(
  async (config) => {
    const token = await store.dispatch('auth/getToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

lms.interceptors.response.use(
  async (response) => {
    return response
  },
  async (err) => {
    if (err.response && (err.response.status === 401 || err.response.status === 403)) {
      await store.dispatch('auth/doLogout')
    }
  }
)

export default lms
